import { useEffect, useRef } from 'react'

export const useGlobalStyle = (style: string) => {
  const styleRef = useRef<HTMLStyleElement>(null)

  useEffect(() => {
    const styleElement = document.createElement('style')
    styleElement.id = `use-global-style-${Math.random().toString(36).substring(2)}`
    document.head.appendChild(styleElement)
    Object.assign(styleRef, { current: styleElement })

    return () => {
      document.head.removeChild(styleElement)
    }
  }, [])

  useEffect(() => {
    requestAnimationFrame(() => {
      if (styleRef.current) {
        styleRef.current.innerHTML = style
      }
    })
  }, [style])
}
